import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { AuthProvider } from "@/features/auth";

interface AppProvidersProps {
  client: QueryClient;
  children: ReactNode;
}

/**
 * Providers transverses. i18n est initialisé avant le rendu, dans main.tsx.
 *
 * `AuthProvider` est à l'intérieur de `QueryClientProvider` : la restauration
 * de session peut déclencher des requêtes, qui ont besoin du client de requête.
 */
export function AppProviders({ client, children }: AppProvidersProps) {
  return (
    <QueryClientProvider client={client}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
